<template>
  <ChatbotButton />
  <v-navigation-drawer v-model="store.open" location="right" :width="420">
    <ChatbotPanel />
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";

import ChatbotButton from "@/components/molecules/chatbot/ChatbotButton.vue";
import ChatbotPanel from "@/components/molecules/chatbot/ChatbotPanel.vue";
import { useChatbotStore } from "@/store/chatbot";

const store = useChatbotStore();

// Signale au reste de l'app que le bouton flottant occupe le coin bas-droit,
// pour que les éléments interactifs alignés à droite (pagination, boutons
// submit, contrôles leaflet) réservent sa zone via .chatbot-fab-clearance.
onMounted(() => document.body.classList.add("has-chatbot-fab"));
onUnmounted(() => document.body.classList.remove("has-chatbot-fab"));
</script>

<style scoped>
:deep(.v-navigation-drawer__content) {
  overflow: hidden;
  mask-image: none;
  -webkit-mask-image: none;
}
</style>
